import { NgModule } from '@angular/core';

import { MercadopagoModule } from './mercadopago/mercadopago.module';
import { PaypalNewModule } from './paypal-new/paypal-new.module';
import { PaypalModule } from './paypal/paypal.module';
import { SpsDecidirModule } from './sps-decidir/sps-decidir.module';

const LIB_MODULES = [
  MercadopagoModule,
  SpsDecidirModule,
  PaypalModule,
  PaypalNewModule,
];

@NgModule({
  imports: LIB_MODULES,
  exports: LIB_MODULES
})
export class PaymentsLibModule { }
